import { buildProductsArray } from './buildData'
import {
  buildBoltonData,
  buildGroupData,
  findAssets,
  findModules,
} from './index'
import { DATA_LAYER_EVENTS } from '../constants'
import { buildUser } from '../services'

// New function to trigger a manual event to the data layer with v2 API data
export const triggerManualEvent = (event, product, previousProduct) => {
  window.smDl.events.push({
    ...event,
    ...buildGroupData(),
    ...buildProductsArray(product, previousProduct),
    user: buildUser(),
  })
}

// Triggers a plan upgrade or downgrade event with upcoming and previous product data
export const triggerBoltonPurchaseEvent = (bolton, type) => {
  window.smDl.events.push({
    // return an upgrade or downgrade event based on product data
    event: DATA_LAYER_EVENTS[`${type}_ADDON_SUCCESS`],
    ...buildBoltonData(bolton, type),
    user: buildUser(),
  })
}

// New function to trigger a manual form event in the data layer
// Accepts event name (required) and formData - form name and fields
export const triggerManualFormEvent = (eventName, formData, errors = []) => {
  triggerManualEvent({
    event: eventName,
    form: {
      id: formData?.id,
      fields: formData?.fields || {},
      // Defaulted errors to an empty array in case of numerous errors.
      // single strings get passed in as ['string']
      errors,
    },
    user: buildUser(),
  })
}

export const triggerModuleLoadEvent = (
  parentElement,
  event = DATA_LAYER_EVENTS.MODULE_LOAD
) => {
  triggerManualEvent({
    event,
    modules: findModules(parentElement),
    assets: findAssets(parentElement),
    user: buildUser(),
  })
}

export const triggerModuleClickEvent = (id, moduleId, type = '') => {
  const moduleItem = {
    id,
    moduleId,
  }

  if (type) {
    moduleItem.type = type
  }

  triggerManualEvent({
    event: DATA_LAYER_EVENTS.MODULE_CLICK,
    moduleItem,
    user: buildUser(),
  })
}
